export default {
  filters: {
    cut: function(value) {
      let n = 140;
      if (!value) return "";
      if (value.length <= n) return value;
      return value.substring(0, n) + "...";
    },
    cutgift: function(value) {
      let n = 50;
      if (!value) return "";
      if (value.length <= n) return value;
      return value.substring(0, n) + "...";
    },
    formatStatus: function(value) {
      let pricing = "";
      switch (value) {
        case 1:
          pricing = "New";
          break;
        case 2:
          pricing = "Popular";
          break;
        case 3:
          pricing = "Sold Out";
          break;
        default:
          pricing = "";
          break;
      }
      return pricing;
    }
  }
};
